import {
  GeneralButtonActionEvent,
  Screen,
  trackEvent,
  UIInteractionType,
} from '@otter-ai/telemetry';

export const trackWorkatoMain = {
  connectWorkato: (name: string) => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        Name: `workato-${name}`,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },
} as const;

export const trackWorkato = {
  main: trackWorkatoMain,
} as const;
